// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__wDZtW","content":"RecentSearches_content__3iSGy"};